import {getComponentInfo, PAGE_TYPE} from "@/common/consts/service.js";
import {schema} from "@/common/utils/webview.js";

export default {
    data() {
        return {
            headerComponent: null,
            componentInfo: getComponentInfo(this.serviceId, PAGE_TYPE.RESPONSE)
        }
    },

    computed: {
        isWebView() {
            return true;
        },
    },

    methods: {
        showFile({index}) {
            this.$router.push({
                name: `${this.type}ResponseFile`,
                query: {
                    ...this.$route.query,
                    order: index
                }
            });
        },
    },

    created() {
        this.componentInfo.headerComponent.then(c => this.headerComponent = c.default);
        this.$eventBus.$on('clickPreviewFile', this.showFile);
    },

    beforeDestroy() {
        this.$eventBus.$off('clickPreviewFile', this.showFile);
    }
}